module.exports = __webpack_public_path__ + "img/ez-theme-switcher-ic-login.a68ce0b7.png";